import { useEffect, useCallback, useState, useMemo } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchCategorias } from "../Slices/Categoria/categoriaSlice";

/**
 * Hook personalizado para obtener categorías desde Redux
 * @returns {Object} Objeto con los datos y funciones del hook
 * @returns {Array} returns.categorias - Lista de categorías activas (estado === 1)
 * @returns {boolean} returns.isLoading - Indica si se están cargando los datos
 * @returns {Function} returns.refetch - Función para volver a cargar los datos
 */
export const useCategorias = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  const categoriasData = useSelector(
    (state) => state.categoria.categorias,
    shallowEqual
  );

  const categorias = useMemo(() => {
    if (!Array.isArray(categoriasData)) return [];
    return categoriasData.filter((item) => Boolean(item.estado));
  }, [categoriasData]);

  const refetch = useCallback(async () => {
    setIsLoading(true);
    await dispatch(fetchCategorias({ codSegmento: "capa" }));
    setIsLoading(false);
  }, [dispatch]);

  useEffect(() => {
    if (!hasLoaded) {
      setHasLoaded(true);
      refetch();
    }
  }, [hasLoaded, refetch]);

  return {
    categorias,
    isLoading,
    refetch,
  };
};
